<template> <router-view/> </template>

<style lang="css">
  body, h1, h2, h3, p, table, th, td, tr, a, ul, li {
    margin: 0px;
    padding: 0px;
  }
</style>